import { render, staticRenderFns } from "./FormResourceResponseComponent.vue?vue&type=template&id=a1482354&scoped=true&lang=pug"
import script from "./FormResourceResponseComponent.vue?vue&type=script&lang=js"
export * from "./FormResourceResponseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1482354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1482354')) {
      api.createRecord('a1482354', component.options)
    } else {
      api.reload('a1482354', component.options)
    }
    module.hot.accept("./FormResourceResponseComponent.vue?vue&type=template&id=a1482354&scoped=true&lang=pug", function () {
      api.rerender('a1482354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/analytic-services/components/FormResourceResponseComponent.vue"
export default component.exports